export default __webpack_public_path__ + "static/media/search-is-nothing-found.9debf9e2.svg";